// Bridge: re-export the iteration details implementation from `src/projects/pages`
import IterationDetails from "../projects/pages/IterationDetails";

export default IterationDetails;
